// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-D+Xz","menu":"styles_menu__tcC4z"};